/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { PayModeDto } from './payModeDto.schema';

export const IReadOnlyListOfPayModeDto = zod.array(zod.lazy(() => PayModeDto));

export type IReadOnlyListOfPayModeDto = zod.input<typeof IReadOnlyListOfPayModeDto>;
export type IReadOnlyListOfPayModeDtoOutput = zod.output<typeof IReadOnlyListOfPayModeDto>;
